export default {
    SET_PATIENT_INFO(state, payload) {
        state.patientInfo = payload;
    },
    SET_PATIENT_ID(state, payload) {
        state.patient_id = payload;
    }
};
